import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="paintings" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Kunstwerke</h2>
        </div>

        {/* Haas Section */}
        <div className="gallery-section">
          <h3>Haas</h3>
          <div className="row paintings-items">
            {props.data?.Haas
              ? props.data.Haas.map((d, i) => (
                  <div
                    key={`haas-${d.title}-${i}`}
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : <div className="col-xs-12"><p>Loading Haas gallery...</p></div>}
          </div>
        </div>

        {/* Fritta Section */}
        <div className="gallery-section">
          <h3>Fritta</h3>
          <div className="row paintings-items">
            {props.data?.Fritta
              ? props.data.Fritta.map((d, i) => (
                  <div
                    key={`fritta-${d.title}-${i}`}
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : <div className="col-xs-12"><p>Loading Fritta gallery...</p></div>}
          </div>
        </div>
      </div>
    </div>
  );
};
